"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HailAbilityHandler = exports.HailActorAbilityFactory = exports.HailAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const enums_1 = require("../../core/enums");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class HailAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Hail;
        this.__typeName = "Hail";
    }
}
exports.HailAbilityArgs = HailAbilityArgs;
let HailActorAbilityFactory = class HailActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Hail", "AllEnemies", 2);
    }
};
HailActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Hail")
], HailActorAbilityFactory);
exports.HailActorAbilityFactory = HailActorAbilityFactory;
let HailAbilityHandler = class HailAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targetFaction = container.getFaction(ability.invokerId) === enums_1.Faction.Ally ? "Enemy"
            : "Ally";
        let didApplyVfx = false;
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies).map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Frost", 60)
                ],
            })),
            onHitOrMiss: sequence => {
                if (!didApplyVfx) {
                    didApplyVfx = true;
                    sequence.push(new core_1.InstantVfxStepArgs(LocationSelector_1.FactionGridLocationSelector.CenterOf(targetFaction), "BlueLightningStorm"));
                }
            }
        });
    }
};
HailAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Hail)
], HailAbilityHandler);
exports.HailAbilityHandler = HailAbilityHandler;
